import { useEffect, useState } from 'react'
import { Form, Modal, Button, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import callApi from '../../helpers/callapi'

const FeeRateConfig = ({ configName = '' }) => {
  const dispatch = useDispatch()
  const [feeRate, setFeeRate] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [selectedFeeRate, setSelectedFeeRate] = useState({ key: '', value: '' })
  const { lotteryPrice } = useSelector((state) => state.webConfig)

  const removeFeeRateHandler = (i) => {
    setFeeRate((feeRate) => {
      const newFeeRate = [...feeRate]
      newFeeRate.splice(i, 1)
      return newFeeRate
    })
  }

  const editFeeRateHandler = (i, value) => {
    setFeeRate((feeRate) => {
      const newFeeRate = [...feeRate]
      newFeeRate[i] = value
      return newFeeRate
    })
    setSelectedFeeRate({ index: 0, key: '', value: '' })
    setShowForm(false)
  }

  const updateFeeRatesHandler = async () => {
    dispatch({ type: 'loading_show' })
    try {
      const data = feeRate.reduce((prev, cur) => {
        prev[cur.key] = Number.parseInt(cur.value)
        return prev
      }, {})
      await callApi({
        url: `/contents/${configName}`,
        method: 'PUT',
        body: { data },
      })
    } catch (err) {
      alert('failed to update fee rates', err)
    }
    dispatch({ type: 'loading_hide' })
  }

  useEffect(() => {
    const fetchFeeRate = async () => {
      try {
        const response = await callApi({
          url: `/contents/${configName}`,
        })
        const feeRate = []
        for (const key in response.value) {
          if (Object.hasOwnProperty.call(response.value, key)) {
            const element = response.value[key]
            feeRate.push({ key, value: element })
          }
        }
        setFeeRate(feeRate)
      } catch (err) {
        setFeeRate([])
      }
    }
    configName && fetchFeeRate()
  }, [configName])

  return (
    <>
      <Button
        className="mb-2"
        onClick={() => {
          setShowForm(true)
          setFeeRate((prev) => {
            const newFeeRate = [...prev]
            setSelectedFeeRate({ index: newFeeRate.length, key: '', value: '' })
            return newFeeRate
          })
        }}
      >
        เพิ่ม Rate ราคา
      </Button>
      <Table responsive striped bordered>
        <thead>
          <tr style={{ textAlign: 'center' }}>
            <th>จำนวนชุด (ใบ)</th>
            <th>ค่าบริการ (บาท)</th>
            <th>ราคา (บาท)</th>
            <th style={{ width: '5%' }}>แก้ไข</th>
            <th style={{ width: '5%' }}>ลบ</th>
          </tr>
        </thead>
        <tbody>
          {feeRate.map((fee, i) => {
            return (
              <tr key={i} style={{ textAlign: 'center' }}>
                <td>{fee.key}</td>
                <td>{fee.value}</td>
                <td>{parseInt(fee.value) + parseInt(lotteryPrice)}</td>
                <td style={{ width: '5%' }}>
                  <Button
                    variant="primary light"
                    onClick={() => {
                      setSelectedFeeRate({ index: i, ...fee })
                      setShowForm(true)
                    }}
                  >
                    <i className="fa fa-pencil"></i>
                  </Button>
                </td>
                <td style={{ width: '5%' }}>
                  <Button variant="danger light" onClick={() => removeFeeRateHandler(i)}>
                    <i className="fa fa-trash"></i>
                  </Button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
      <div style={{ textAlign: 'center' }}>
        <Button onClick={updateFeeRatesHandler}>บันทึก</Button>
      </div>
      <UpdateFeeRateModal
        show={showForm}
        onClose={() => {
          setShowForm(false)
          setSelectedFeeRate({ index: 0, key: '', value: '' })
        }}
        fee={selectedFeeRate}
        onUpdate={editFeeRateHandler}
      />
    </>
  )
}

const UpdateFeeRateModal = ({ show, onClose, onUpdate, fee = { index: 0, key: '', value: '' } }) => {
  const [keyInput, setKeyInput] = useState('')
  const [valueInput, setValueInput] = useState('')

  useEffect(() => {
    setKeyInput(fee.key)
    setValueInput(fee.value)
  }, [fee.index, fee.key, fee.value])

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>ปรับ Rate ราคา</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ textAlign: 'center' }}>
        <div className="d-flex mt-2 mb-4">
          <Form.Control
            type="text"
            placeholder="จำนวนชุด"
            defaultValue={keyInput}
            onChange={(e) => setKeyInput(e.target.value)}
          />
          <Form.Control
            type="text"
            placeholder="ค่าบริการ"
            defaultValue={valueInput}
            onChange={(e) => setValueInput(e.target.value)}
          />
        </div>
        <Button onClick={() => onUpdate(fee.index, { key: keyInput, value: valueInput })}>ยืนยัน</Button>
      </Modal.Body>
    </Modal>
  )
}

export default FeeRateConfig
